import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton/CustomButton";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// const MyWalletsLogo = `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`;
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
	blockCustomerOperationsList,
	resetBlockCustomerOperationsList
} from "../../redux/actions/blockCustomerOperationsListAction";

import {
	resetGetOperationList,
	getOperationList
} from "../../redux/actions/getOperationListAction";

import {
	resetGetBlockCustomerOperationsList,
	getBlockCustomerOperationsList
} from "../../redux/actions/getBlockCustomerOperationsListAction";

import {
	unBlockCustomerOperation,
	resetUnBlockCustomerOperation
} from "../../redux/actions/unBlockCustomerOperationAction";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import BackButton from "../../components/BackButton/BackButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SOLogout from "../../components/Logout/SOLogout";
import "../../components/LoadingSpinner/spinner.css";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";
 
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function ActionCustomerMaster() {
	const classes = useStyles();
	const location = useLocation();
	const customerId = location.search.split("?userId =")[1];
	const dispatch = useDispatch();
	const partnerloginUser = useSelector(({ login }) => login);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const blockCustomerOperationsRes = useSelector(
		({ blockCustomerOperations }) => blockCustomerOperations
	);

	// var authToken = partnerloginUser.data.AuthToken;
    // if (regenerateTkn.success !== prevProps.regenerateTkn.success) {
	// 	const newToken = regenerateTkn.data.authToken;
	// 	localStorage.setItem("authToken", newToken);
	// 	// Ensure this updated token is used in subsequent requests
	// 	authToken = newToken;
	//   }
	  

	
	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    var authToken = regenerateTokenRes.data.AuthToken;
	

     
	//allready handled useselector is correct
	//use local storage
	//use effect with getregenerate and update state 

	const [getOperationListResArray, setGetOperationListResArray] = useState([]);
	const [getOperationListStatus, setGetOperationListStatus] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [notificationOpenBlock, setNotificationOpenBlock] =
		React.useState(false);

	const [unBlockCustomerOperationStatus, setUnBlockCustomerOperationStatus] =
		useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const [getBlockCusOperationsListRes, setgetBlockCusOperationsListRes] =
		useState("");

	const [
		unBlockCustomerOperationResArray,
		setunBlockCustomerOperationResArray
	] = useState([]);

	const [
		getBlockCustomerOperationsListResArray,
		setGetBlockCustomerOperationsListResArray
	] = useState([]);
	//getBlockCustomerOperationsListRes
	const [
		getBlockCustomerOperationsListStatus,
		setGetBlockCustomerOperationsListStatus
	] = useState(false);

	const [
		blockCustomerOperationsListStatus,
		setBlockCustomerOperationsListStatus
	] = useState(false);

	const [operation, setOperation] = useState('');

	const [blockCustomerOperationResArray, setBlockCustomerOperationResArray] =
		useState([]);

	// const customerWalletCurrencyListRes = useSelector(
	//   ({ getCustomerWalletCurrencyList }) => getCustomerWalletCurrencyList
	// );

	const customerWalletCurrencyListRes = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	//unBlockCustomerOperation
	const unBlockCustomerOperationRes = useSelector(
		({ unBlockCustomerOperation }) => unBlockCustomerOperation
	);

	const getOperationListRes = useSelector(
		({ getOperationList }) => getOperationList
	);

	const getBlockCustomerOperationsListRes = useSelector(
		({ getBlockCustomerOperationsList }) => getBlockCustomerOperationsList
	);

	const [currencyIs, setCurrency] = useState("");
	const [customerWalletCurrencyArray, setCustomerWalletCurrencyArray] =
		useState([]);

	const customerWalletCurrencyListResFunc = () => {
		if (customerWalletCurrencyListRes.data.status == "success") {
			setCustomerWalletCurrencyArray(customerWalletCurrencyListRes.data);
		}
		if (customerWalletCurrencyListRes.data.status == "Failed") {
			setCustomerWalletCurrencyArray(customerWalletCurrencyListRes);
			if (
				customerWalletCurrencyListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				customerWalletCurrencyListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (customerWalletCurrencyListRes.data.status == "failed") {
			setCustomerWalletCurrencyArray(customerWalletCurrencyListRes);
			if (
				customerWalletCurrencyListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				customerWalletCurrencyListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	};
	useEffect(() => {
		customerWalletCurrencyListResFunc();
	}, [customerWalletCurrencyListRes.data.status]);

	const getOperationListResFunc = () => {
		// if (getOperationListStatus) {
		if (getOperationListRes.success) {
			setGetOperationListResArray(getOperationListRes.data.operationBlockType);
		}
		// }
	};

	useEffect(() => {
		getOperationListResFunc();
	}, [getOperationListRes.success]);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			// setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "operation") {
			// setOperation(value);
			setOperation(value == "All" ? "" : value);
		}
	};

	const setGetOperationListStatusFunc = () => {
		setGetOperationListStatus(true);
		const getOperationListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(getOperationList(getOperationListReq, authToken));
	};

	// useEffect(() => {
	//   setGetOperationListStatusFunc();
	// }, []);

	const getBlockCustomerListRequest = () => {
		setBlockCustomerOperationsListStatus(true);
		getBlockCustomerListApi();
		setBlockCustomerOperationResArray([]);
		// setGetBlockCustomerOperationsListStatusFunc();
	};

	const unBlockHandle = (customerId, operationName, blockId) => {
		setUnBlockCustomerOperationStatus(true);

		const unBlockCustomerOperationReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId,
				operationName: operationName,
				blockId: blockId
			}
		};

		dispatch(unBlockCustomerOperation(unBlockCustomerOperationReq, authToken));
	};

	const getBlockCustomerListApi = () => {
		setIsLoading(true);
		setGetBlockCustomerOperationsListStatus(false);
		setGetOperationListStatus(true);
		const getBlockCustomerListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId,
				operationName: operation,
				currency: currencyIs
			}
		};
		dispatch(blockCustomerOperationsList(getBlockCustomerListReq, authToken));
	};

	const blockCustomerOperationsListStatusFunc = () => {
		if (blockCustomerOperationsListStatus) {
			if (blockCustomerOperationsRes.data.status == "Success") {
				setIsLoading(false);
				setGetBlockCustomerOperationsListResArray([]);
				// setBlockCustomerOperationResArray(
				// 	[].concat(blockCustomerOperationsRes.data.operationList)
				// );
				setNotificationOpenBlock(true);
				setgetBlockCusOperationsListRes(blockCustomerOperationsRes.data);
				// setBlockCustomerOperationResArray([].concat(getBlockCustomerOperationsListRes.data.operationList));
				setGetBlockCustomerOperationsListStatusFunc();
			}
			if (blockCustomerOperationsRes.data.status == "Failed") {
				setIsLoading(false);
				setGetBlockCustomerOperationsListResArray([]);
				setBlockCustomerOperationResArray(blockCustomerOperationsRes.data);
				setNotificationOpenBlock(true);
				setgetBlockCusOperationsListRes(blockCustomerOperationsRes.data);
				if (
					blockCustomerOperationsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					blockCustomerOperationsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (blockCustomerOperationsRes.data.status == "failed") {
				setIsLoading(false);
				setGetBlockCustomerOperationsListResArray([]);
				setBlockCustomerOperationResArray(blockCustomerOperationsRes.data);
				setNotificationOpenBlock(true);
				setgetBlockCusOperationsListRes(blockCustomerOperationsRes.data);
				if (
					blockCustomerOperationsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					blockCustomerOperationsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (blockCustomerOperationsRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setGetBlockCustomerOperationsListResArray([]);
				setBlockCustomerOperationResArray(blockCustomerOperationsRes.data);
				setNotificationOpenBlock(true);
				setgetBlockCusOperationsListRes(blockCustomerOperationsRes.data);
			}
		}
	};

	useEffect(() => {
		blockCustomerOperationsListStatusFunc();
	}, [blockCustomerOperationsRes.data.status]);

	//unBlockCustomerOperation
	const unBlockCustomerOperationStatusFunc = () => {
		if (unBlockCustomerOperationStatus) {
			if (unBlockCustomerOperationRes.data.status == "success") {
				setNotificationOpen(true);
				setunBlockCustomerOperationResArray(unBlockCustomerOperationRes.data);
				setGetBlockCustomerOperationsListStatusFunc();
			}
			if (unBlockCustomerOperationRes.data.status == "failed") {
				setNotificationOpen(true);
				setunBlockCustomerOperationResArray(unBlockCustomerOperationRes.data);
				if (
					unBlockCustomerOperationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					unBlockCustomerOperationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (unBlockCustomerOperationRes.data.status == "Failed") {
				setNotificationOpen(true);
				setunBlockCustomerOperationResArray(unBlockCustomerOperationRes.data);
				if (
					unBlockCustomerOperationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					unBlockCustomerOperationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		unBlockCustomerOperationStatusFunc();
	}, [unBlockCustomerOperationRes.data.status]);

	const setGetBlockCustomerOperationsListStatusFunc = () => {
		setGetBlockCustomerOperationsListStatus(true);
		//setGetOperationListStatus(false);

		const getBlockCustomerOperationsListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				custmerId: customerId
			}
		};

		return dispatch(
			getBlockCustomerOperationsList(
				getBlockCustomerOperationsListReq,
				regenerateTokenRes.data.AuthToken
				//authToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setGetBlockCustomerOperationsListStatusFunc();
			setGetOperationListStatusFunc();
		}
	}, [regenerateTokenRes.data.status]);

	//getBlockCustomerOperationsListStatus
	const getBlockCustomerOperationsListStatusFunc = () => {
		if (getBlockCustomerOperationsListStatus) {
			if (getBlockCustomerOperationsListRes.data.status == "Success") {
				setBlockCustomerOperationResArray([]);
				// setGetBlockCustomerOperationsListResArray(
				//   [].concat(getBlockCustomerOperationsListRes.data.operationList)
				// );
				setBlockCustomerOperationResArray(
					[].concat(getBlockCustomerOperationsListRes.data.operationList)
				);

				// setBlockCustomerOperationResArray(
				//   getBlockCustomerOperationsListRes.data.operationList
				// );
			}
			if (getBlockCustomerOperationsListRes.data.status == "success") {
				setBlockCustomerOperationResArray([]);
				setBlockCustomerOperationResArray(
					[].concat(getBlockCustomerOperationsListRes.data.operationList)
				);

				// setBlockCustomerOperationResArray(
				//   getBlockCustomerOperationsListRes.data.operationList
				// );
			}
			if (getBlockCustomerOperationsListRes.data.status == "Failed") {
				setBlockCustomerOperationResArray([]);
				setGetBlockCustomerOperationsListResArray(
					getBlockCustomerOperationsListRes.data
				);

				if (
					getBlockCustomerOperationsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getBlockCustomerOperationsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}

				// setBlockCustomerOperationResArray(
				//   getBlockCustomerOperationsListRes.data
				// );
			}
			if (getBlockCustomerOperationsListRes.data.status == "failed") {
				setBlockCustomerOperationResArray([]);
				setGetBlockCustomerOperationsListResArray(
					getBlockCustomerOperationsListRes.data
				);

				if (
					getBlockCustomerOperationsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getBlockCustomerOperationsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}

				// setBlockCustomerOperationResArray(
				//   getBlockCustomerOperationsListRes.data
				// );
			}

			if (getBlockCustomerOperationsListRes.data.status == "NOT FOUND") {
				setBlockCustomerOperationsListStatus(false);
				setBlockCustomerOperationResArray([]);
				setGetBlockCustomerOperationsListResArray(
					getBlockCustomerOperationsListRes.data
				);
			}
		}
	};

	useEffect(() => {
		getBlockCustomerOperationsListStatusFunc();
	}, [getBlockCustomerOperationsListRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handlePopupNoticationClose = () => {
		setNotificationOpenBlock(false);
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Select Currency"
								required
								// value={currencyIs}
								defaultValue={"Select Currency" || currencyIs}
								name="currency"
								fullWidth={true}
								select
								onChange={handleChange}
								variant="standard"

							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{(() => {
									if (customerWalletCurrencyArray.currencyList) {
										if (!customerWalletCurrencyArray.currencyList) {
											return <MenuItem>No currencies</MenuItem>;
										}
										return customerWalletCurrencyArray.currencyList && [].concat(customerWalletCurrencyArray.currencyList).map((c) => (
											<MenuItem value={c} key={c}>
												{c}
											</MenuItem>
										));
									} else {
										return <MenuItem>No currencies</MenuItem>;
										// return <MenuItem>{t("Something went wrong")}</MenuItem>;
									}
								})()}
							</TextField>
						</Grid>

						<Grid item sm={12} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Operation"
								required
								// value={operation}
								defaultValue={"All" || operation}
								name="operation"
								// variant="outlined"
								fullWidth={true}
								select
								onChange={handleChange}
								variant="standard"

							>
								<MenuItem value="All" selected="All">
									ALL
								</MenuItem>
								{(() => {
									if (getOperationListResArray) {
										return getOperationListResArray.map((c) => (
											<MenuItem value={c} key={c}>
												{c}
											</MenuItem>
										));
									} else {
										return <MenuItem>No Data</MenuItem>;
										// return <MenuItem>{t("Something went wrong")}</MenuItem>;
									}
								})()}
							</TextField>

							{/* <TextField
                size="small"
                color="primary"
                autoFocus={true}
                type="text"
                label="Risk Group"
                value={operation}
                name="operation"
                // variant="outlined"
                fullWidth={true}
                select
                onChange={handleChange}
              >
                <MenuItem value={"Cashout"}>Cashout</MenuItem>
                <MenuItem value={"Load"}>Load </MenuItem>
                <MenuItem value={"Pay"}>Pay</MenuItem>
                <MenuItem value={"PayOrder"}>Pay Order</MenuItem>
                <MenuItem value={"Purchase"}>Purchase </MenuItem>
                <MenuItem value={"request"}>Request</MenuItem>
                <MenuItem value={"Transfer"}>Transfer</MenuItem>
                <MenuItem value={"Wallet Transfer"}>Wallet Transfer </MenuItem>
                <MenuItem value={"Withdraw"}>Withdraw</MenuItem>
                <MenuItem value={"OwnerLoginBlock"}>OwnerLoginBlock</MenuItem>
                <MenuItem value={"UserLoginBlock"}>UserLoginBlock </MenuItem>
              </TextField> */}
						</Grid>

						<Grid item sm={12} md={4} lg={4}>
							{/* <NavLink to="/payment/Yearly4499FreeTrial?gift=true"> */}
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={getBlockCustomerListRequest}
              >
                BLOCK
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getBlockCustomerListRequest}
							>
								BLOCK
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{isLoading ? (
					<LoadingSpinner />
				) : blockCustomerOperationResArray.status == "Failed" ||
					getBlockCustomerOperationsListResArray.status == "Failed" || getBlockCustomerOperationsListResArray.status == "NOT FOUND" ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Block Operation
								</Typography>
							</Grid>
							<Grid sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : blockCustomerOperationsListStatus ? (
					// <Card>
					// 	<Grid
					// 		container
					// 		style={{
					// 			padding: "10px"
					// 		}}
					// 	>
					// 		<Grid xs={12} sm={12} md={12} lg={12}>
					// 			<Typography
					// 				variant="body1"
					// 				style={{ fontWeight: "700" }}
					// 				className="themeText"
					// 			>
					// 				Block Operation
					// 			</Typography>
					// 		</Grid>
					// 		<TableContainer component={Paper} className="my-3">
					// 			<Table
					// 				className={classes.table}
					// 				size="small"
					// 				aria-label="a dense table"
					// 			>
					// 				<TableHead>
					// 					<TableRow className="themeBackground">
					// 						<TableCell
					// 							align="center"
					// 							style={{ fontWeight: "bold", color: "white" }}
					// 						>
					// 							Customer Id{" "}
					// 						</TableCell>
					// 						<TableCell
					// 							align="center"
					// 							style={{ fontWeight: "bold", color: "white" }}
					// 						>
					// 							{" "}
					// 							Currency
					// 						</TableCell>
					// 						<TableCell
					// 							align="center"
					// 							style={{ fontWeight: "bold", color: "white" }}
					// 						>
					// 							{" "}
					// 							Blocked Operation
					// 						</TableCell>
					// 						<TableCell
					// 							align="center"
					// 							style={{ fontWeight: "bold", color: "white" }}
					// 						>
					// 							Action
					// 						</TableCell>
					// 					</TableRow>
					// 				</TableHead>
					// 				<TableBody>
					// 					{blockCustomerOperationResArray &&
					// 						[]
					// 							.concat(blockCustomerOperationResArray)
					// 							.slice(
					// 								page * rowsPerPage,
					// 								page * rowsPerPage + rowsPerPage
					// 							)
					// 							.map((row, index) => (
					// 								<TableRow key={index}>
					// 									<TableCell align="center">
					// 										{row.customerId}
					// 									</TableCell>

					// 									<TableCell align="center">{row.currency}</TableCell>

					// 									<TableCell align="center">
					// 										{row.operationName
					// 											? row.operationName
					// 											: row.block}
					// 									</TableCell>

					// 									<TableCell align="center">
					// 										<CustomButton
					// 											style={{
					// 												padding: "8px"
					// 											}}
					// 											onClick={() =>
					// 												unBlockHandle(
					// 													row.customerId,
					// 													row.operationName
					// 														? row.operationName
					// 														: row.block,
					// 													row.userName
					// 												)
					// 											}
					// 										>
					// 											UnBlock
					// 										</CustomButton>
					// 									</TableCell>
					// 								</TableRow>
					// 							))}
					// 				</TableBody>
					// 			</Table>
					// 			<TablePagination
					// 				rowsPerPageOptions={[5, 10, 25]}
					// 				component="div"
					// 				count={[].concat(blockCustomerOperationResArray).length}
					// 				rowsPerPage={rowsPerPage}
					// 				page={page}
					// 				onChangePage={handleChangePage}
					// 				onChangeRowsPerPage={handleChangeRowsPerPage}
					// 			/>
					// 		</TableContainer>
					// 	</Grid>
					// </Card>
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Action Customer Master
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Blocked Operation
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{blockCustomerOperationResArray &&
											[]
												.concat(blockCustomerOperationResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell align="center">
															{/* // onClick={() => sendCustomerId(row.customerId)} */}
															{row.customerId}
														</TableCell>

														<TableCell align="center">{row.currency}</TableCell>

														<TableCell align="center">{row.block}</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	unBlockHandle(
																		row.customerId,
																		row.operationName
																			? row.operationName
																			: row.block,
																		row.userName
																	)
																}
															>
																UnBlock
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={[].concat(blockCustomerOperationResArray).length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				) : getBlockCustomerOperationsListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Action Customer Master
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Blocked Operation
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{blockCustomerOperationResArray &&
											[]
												.concat(blockCustomerOperationResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														<TableCell align="center">
															{/* // onClick={() => sendCustomerId(row.customerId)} */}
															{row.customerId}
														</TableCell>

														<TableCell align="center">{row.currency}</TableCell>

														<TableCell align="center">{row.block}</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	unBlockHandle(
																		row.customerId,
																		row.operationName
																			? row.operationName
																			: row.block,
																		row.userName
																	)
																}
															>
																UnBlock
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={[].concat(blockCustomerOperationResArray).length}
									rowsPerPage={rowsPerPage}
									page={page}
									onChangePage={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				) : (
					""
				)}
			</Layout>

			{unBlockCustomerOperationResArray.status && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								{unBlockCustomerOperationResArray.status == "success"
									? "Operation unblock successfully"
									: "Operation is not unblock"}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{getBlockCusOperationsListRes.status == "Success" && (
				<div>
					<Dialog
						open={notificationOpenBlock}
						onClose={handlePopupNoticationClose}
					>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getBlockCusOperationsListRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handlePopupNoticationClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handlePopupNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{getBlockCusOperationsListRes.status == "Failed" && (
				<div>
					<Dialog
						open={notificationOpenBlock}
						onClose={handlePopupNoticationClose}
					>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getBlockCusOperationsListRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handlePopupNoticationClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handlePopupNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{/* {updateCustomerDetailArray.status == "Success" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={success} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {updateCustomerDetailArray.result.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}

			{/* {updateCustomerDetailArray.status == "failed" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {updateCustomerDetailArray.result.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}  */}
		</>
	);
}

export default ActionCustomerMaster;
